import { render, staticRenderFns } from "./DepartmentSelector.vue?vue&type=template&id=3cb48d0c&scoped=true&"
import script from "./DepartmentSelector.vue?vue&type=script&lang=js&"
export * from "./DepartmentSelector.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentSelector.vue?vue&type=style&index=0&id=3cb48d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb48d0c",
  null
  
)

export default component.exports